<template>
    <v-btn-toggle
        multiple
        dense
        rounded
        mandatory
        style="background-color: #555"
        v-model="model"
    >
        <v-btn v-show="isVisible('invited')" text value="invited">
            <v-icon class="mr-2">mdi-at</v-icon>
            <span>Invited</span>
        </v-btn>

        <v-btn v-show="isVisible('reminded')" text value="reminded">
            <v-icon class="mr-2">mdi-at</v-icon>
            <span>Reminded</span>
        </v-btn>

        <v-btn v-show="isVisible('opened')" text value="opened">
            <v-icon class="mr-2">mdi-email-open-outline</v-icon>
            <span>Opened</span>
        </v-btn>

        <v-btn v-show="isVisible('started')" text value="started">
            <v-icon class="mr-2">mdi-clock-start</v-icon>
            <span>Started</span>
        </v-btn>

        <v-btn v-show="isVisible('profile')" text value="profile">
            <v-icon class="mr-2">mdi-cancel</v-icon>
            <span>Profile</span>
        </v-btn>

        <v-btn v-show="isVisible('quota')" text value="quota">
            <v-icon class="mr-2">mdi-cancel</v-icon>
            <span>Quota</span>
        </v-btn>

        <v-btn v-show="isVisible('quality')" text value="quality">
            <v-icon class="mr-2">mdi-cancel</v-icon>
            <span>Quality</span>
        </v-btn>

        <v-btn v-show="isVisible('duplicate')" text value="duplicate">
            <v-icon class="mr-2">mdi-account-switch</v-icon>
            <span>Duplicate</span>
        </v-btn>

        <v-btn v-show="isVisible('security')" text value="security">
            <v-icon class="mr-2">mdi-security</v-icon>
            <span>Security</span>
        </v-btn>

        <v-btn v-show="isVisible('completed')" text value="completed">
            <v-icon class="mr-2">mdi-check</v-icon>
            <span>Completed</span>
        </v-btn>
    </v-btn-toggle>

</template>

<script>
export default {

    name: "ProjectStatusSelector",

    props: {
        value: {
            type: Array,
            required: true,
        },
        only: {
            type: Array,
            required: false,
            default: () => [],
        },
        disableStatuses: {
            type: Array,
            required: false,
            default: () => [],
        }
    },

    computed: {
        model: {
            get() {
                return this.value;
            },

            set(values) {
                this.$emit('input', values);
            }
        }
    },

    methods: {
        isVisible(field) {

            if (this.disableStatuses.length > 0) {
                return !this.disableStatuses.includes(field)
            }

            if (this.only.length > 0) {
                return this.only.includes(field);
            }
            return true;
        }
    }
}
</script>

<style scoped>

</style>